var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CondNode__container"},[_c('h4',[_vm._v("Conditional")]),_c('v-switch',{attrs:{"label":`Branch: ${_vm.branch ? 'YES' : 'NO'}`},on:{"change":_vm.onUpdate},model:{value:(_vm.branch),callback:function ($$v) {_vm.branch=$$v},expression:"branch"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }